export default (context) => {
    if(context.main.length === 0) {
        context.overlay = true
        context.alert.step = 1
        context.alert.status = true
    } else if(context.main.length > 0 && context.main.length < 3) {
        context.overlay = true
        context.alert.step = 2
        context.alert.status = true
    } else if( context.main.length > 3 && context.main[context.main.length - 1].type === 'text') {
        context.overlay = true
        context.alert.step = 3
        context.alert.status = true
    } else {
        if(context.checkVideos) {
            context.ending.length > 0  ? context.$router.push('/survey') : context.$router.push('/add-ending')
        }
    }
}